import { useIntl } from '@/i18n';
import { history } from '@/router/navigate';
import { Button, Result } from 'antd';

interface ForbiddenProps {
  /** 被挡下的那一页的菜单键（路由 `handle.access`）；页面级 403 没有接口响应，只能用它对上「哪一页」 */
  menuKey?: string;
}

/**
 * 403 页。**只展示固定文案**（联系超级管理员或本会负责权限配置的管理员）与被挡的页面：
 * 会话码集每请求现算，重新登录不会变，所以这里不提示重新登录、也不触发重取会话。
 * 接口 403 的缺失码走全局提示（`utils/http.ts` 的 `missingCodesOf`），不在本页展示。
 */
export default function Forbidden({ menuKey }: ForbiddenProps) {
  const intl = useIntl();
  return (
    <Result
      status="403"
      title={intl.formatMessage({ id: 'error.403.title' })}
      subTitle={intl.formatMessage({ id: 'http.permissionMissingNoCodes' })}
      extra={
        <div className="flex flex-col items-center gap-2">
          {menuKey ? (
            <div className="text-secondary">
              {intl.formatMessage({ id: 'error.403.menuKey' }, { key: menuKey })}
            </div>
          ) : null}
          <Button type="primary" onClick={() => history.push('/')}>
            {intl.formatMessage({ id: 'error.backHome' })}
          </Button>
        </div>
      }
    />
  );
}
